export const SAVE = 'stepTripCancellationTugo.SAVE';
export const VALUE_CHANGED = 'stepTripCancellationTugo.VALUE_CHANGED';
export const LOAD = 'stepTripCancellationTugo.LOAD';
export const NEXT = 'stepTripCancellationTugo.NEXT';
export const RESET = 'stepTripCancellationTugo.RESET';
export const RESET_FORM_STATE = 'stepTripCancellationTugo.RESET_FORM_STATE';




// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.TripCancellation/constants.js